import React from "react";

export default function Items({ Links, title }) {
  return (
    <div>
      <ul>
        <h1 className="mb-1 text-4xl font-semibold text-primary-green">
          {title}
        </h1>
        {Links.map((links) => (
          <li key={links.name}>
            <a
              href={links.link}
              className="cursor-pointer text-xl text-primary-blue hover:text-primary-purple
                     md:text-2xl"
            >
              {links.name}
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
}
